@if (productId(); as pid) {
  @if (shopId(); as sid) {
    <div
      class="fixed inset-0 flex flex-col overflow-hidden bg-neutral-900/25 p-3 sm:p-5 kiosk-xl:p-8"
      [style.z-index]="($any(index$ | async) ?? 0) + 100"
      (click)="closeAsDismissed()"
    >
      <div
        class="relative flex min-h-0 flex-1 flex-col overflow-hidden rounded-2xl bg-white shadow-2xl ring-1 ring-black/5 kiosk-xl:rounded-3xl p-8"
        (click)="$event.stopPropagation()"
      >
        <button
          type="button"
          (click)="closeAsDismissed()"
          class="icon icon-cross absolute right-4 top-4 z-10 h-8 w-8 shrink-0 rounded-full text-xs kiosk:right-6 kiosk:top-6 kiosk:h-16 kiosk:w-16 kiosk:text-3xl"
          [style.background-color]="'var(--ui-color-primary-200)'"
          [style.color]="'var(--ui-color-primary-900)'"
        ></button>
        <app-kiosk-product-add-shell
          class="min-h-0 flex-1"
          [productId]="pid"
          [shopId]="sid"
          [backgroundColor]="themeColors()?.backgroundColor"
          [secondaryColor]="themeColors()?.secondaryColor"
          [textColor]="themeColors()?.textColor"
          [buttonBackgroundColor]="themeColors()?.buttonBackgroundColor"
          [buttonTextColor]="themeColors()?.buttonTextColor"
          [unavailableButtonBackground]="themeColors()?.unavailableButtonBackground"
          [unavailableButtonText]="themeColors()?.unavailableButtonText"
          [cardColor]="themeColors()?.cardColor"
          [compositionBackgroundColor]="themeColors()?.compositionBackgroundColor"
          (addToCartRequest)="onShellAddToCart($event)"
          (backRequest)="closeAsDismissed()"
        />
      </div>
    </div>
  }
}
